export default {
  CODE852: "+852 Hong Kong",
  CODE853: "+853 Macau",
  CODE86: "+86 China (Mainland of)",
  CODE886: "+886 Taiwan",
  CODE1: "+1 North America",
  CODE7: "+7 Russia",
  CODE20: "+20 Egypt",
  CODE27: "+27 South Africa",
  CODE30: "+30 Greece",
  CODE31: "+31 Netherlands",
  CODE32: "+32 Belgium",
  CODE33: "+33 France",
  CODE34: "+34 Spain",
  CODE36: "+36 Hungary",
  CODE39: "+39 Italy",
  CODE40: "+40 Romania",
  CODE41: "+41 Switzerland",
  CODE43: "+43 Austria",
  CODE44: "+44 United Kingdom",
  CODE45: "+45 Denmark",
  CODE46: "+46 Sweden",
  CODE47: "+47 Norway",
  CODE48: "+48 Poland",
  CODE49: "+49 Germany",
  CODE51: "+51 Peru",
  CODE52: "+52 Mexico",
  CODE53: "+53 Cuba",
  CODE54: "+54 Argentina",
  CODE55: "+55 Brazil",
  CODE56: "+56 Chile / Easter Island",
  CODE57: "+57 Colombia",
  CODE58: "+58 Venezuela",
  CODE60: "+60 Malaysia",
  CODE61: "+61 Australia",
  CODE62: "+62 Indonesia",
  CODE63: "+63 Philippines",
  CODE64: "+64 New Zealand",
  CODE65: "+65 Singapore",
  CODE66: "+66 Thailand",
  CODE81: "+81 Japan",
  CODE82: "+82 Korea, South",
  CODE84: "+84 Vietnam",
  CODE90: "+90 Turkey",
  CODE91: "+91 India",
  CODE92: "+92 Pakistan",
  CODE93: "+93 Afghanistan",
  CODE94: "+94 Sri Lanka",
  CODE95: "+95 Burma",
  CODE98: "+98 Iran",
  CODE211: "+211 South Sudan",
  CODE212: "+212 Morocco",
  CODE213: "+213 Algeria",
  CODE216: "+216 Tunisia",
  CODE218: "+218 Libya",
  CODE220: "+220 Gambia",
  CODE221: "+221 Senegal",
  CODE222: "+222 Mauritania",
  CODE223: "+223 Mali",
  CODE224: "+224 Guinea",
  CODE225: "+225 Côte d'Ivoire",
  CODE226: "+226 Burkina Faso",
  CODE227: "+227 Niger",
  CODE228: "+228 Togo",
  CODE229: "+229 Benin",
  CODE230: "+230 Mauritius",
  CODE231: "+231 Liberia",
  CODE232: "+232 Sierra Leone",
  CODE233: "+233 Ghana",
  CODE234: "+234 Nigeria",
  CODE235: "+235 Chad",
  CODE236: "+236 Central African Republic",
  CODE237: "+237 Cameroon",
  CODE238: "+238 Cape Verde",
  CODE239: "+239 São Tomé and Príncipe",
  CODE240: "+240 Equatorial Guinea",
  CODE241: "+241 Gabon",
  CODE242: "+242 Congo",
  CODE243: "+243 Congo, Democratic Republic",
  CODE244: "+244 Angola",
  CODE245: "+245 Guinea-Bissau",
  CODE246: "+246 British Indian Ocean Territory (United Kingdom)",
  CODE247: "+247 Ascension (United Kingdom)",
  CODE248: "+248 Seychelles",
  CODE249: "+249 Sudan",
  CODE250: "+250 Rwanda",
  CODE251: "+251 Ethiopia",
  CODE252: "+252 Somalia",
  CODE253: "+253 Djibouti",
  CODE254: "+254 Kenya",
  CODE255: "+255 Tanzania / Zanzibar",
  CODE256: "+256 Uganda",
  CODE257: "+257 Burundi",
  CODE258: "+258 Mozambique",
  CODE260: "+260 Zambia",
  CODE261: "+261 Madagascar",
  CODE262: "+262 Mayotte / Réunion",
  CODE263: "+263 Zimbabwe",
  CODE264: "+264 Namibia",
  CODE265: "+265 Malawi",
  CODE266: "+266 Lesotho",
  CODE267: "+267 Botswana",
  CODE268: "+268 Swaziland",
  CODE269: "+269 Comoros",
  CODE290: "+290 Saint Helena (United Kingdom)",
  CODE291: "+291 Eritrea",
  CODE297: "+297 Aruba (Netherlands)",
  CODE298: "+298 Faroe Islands (Denmark)",
  CODE299: "+299 Greenland (Denmark)",
  CODE350: "+350 Gibraltar (United Kingdom)",
  CODE351: "+351 Portugal",
  CODE352: "+352 Luxembourg",
  CODE353: "+353 Ireland",
  CODE354: "+354 Iceland",
  CODE355: "+355 Albania",
  CODE356: "+356 Malta",
  CODE357: "+357 Cyprus",
  CODE358: "+358 Finland",
  CODE359: "+359 Bulgaria",
  CODE370: "+370 Lithuania",
  CODE371: "+371 Latvia",
  CODE372: "+372 Estonia",
  CODE373: "+373 Moldova",
  CODE374: "+374 Armenia",
  CODE375: "+375 Belarus",
  CODE376: "+376 Andorra",
  CODE377: "+377 Monaco",
  CODE378: "+378 San Marino",
  CODE379: "+379 Vatican City",
  CODE380: "+380 Ukraine",
  CODE381: "+381 Serbia",
  CODE382: "+382 Montenegro",
  CODE385: "+385 Croatia",
  CODE386: "+386 Slovenia",
  CODE387: "+387 Bosnia and Herzegovina",
  CODE389: "+389 Macedonia",
  CODE420: "+420 Czech Republic",
  CODE421: "+421 Slovakia",
  CODE423: "+423 Liechtenstein",
  CODE500: "+500 British Overseas Territory (United Kingdom)",
  CODE501: "+501 Belize",
  CODE502: "+502 Guatemala",
  CODE503: "+503 El Salvador",
  CODE504: "+504 Honduras",
  CODE505: "+505 Nicaragua",
  CODE506: "+506 Costa Rica",
  CODE507: "+507 Panama",
  CODE508: "+508 Saint Pierre and Miquelon (France)",
  CODE509: "+509 Haiti",
  CODE590: "+590 French overseas (France)",
  CODE591: "+591 Bolivia",
  CODE592: "+592 Guyana",
  CODE593: "+593 Ecuador",
  CODE594: "+594 French Guiana (France)",
  CODE595: "+595 Paraguay",
  CODE596: "+596 French Antilles (France)",
  CODE597: "+597 Suriname",
  CODE598: "+598 Uruguay",
  CODE599: "+599 Dutch Caribbean islands (Netherlands)",
  CODE670: "+670 East Timor",
  CODE672: "+672 Australian External Territories (Australia)",
  CODE673: "+673 Brunei Darussalam",
  CODE674: "+674 Nauru",
  CODE675: "+675 Papua New Guinea",
  CODE676: "+676 Tonga",
  CODE677: "+677 Solomon Islands",
  CODE678: "+678 Vanuatu",
  CODE679: "+679 Fiji",
  CODE680: "+680 Palau",
  CODE681: "+681 Wallis and Futuna (France)",
  CODE682: "+682 Cook Islands (New Zealand)",
  CODE683: "+683 Niue (New Zealand)",
  CODE685: "+685 Samoa",
  CODE686: "+686 Kiribati",
  CODE687: "+687 New Caledonia (France)",
  CODE688: "+688 Tuvalu",
  CODE689: "+689 French Polynesia (France)",
  CODE690: "+690 Tokelau (New Zealand)",
  CODE691: "+691 Micronesia, Federated States of",
  CODE692: "+692 Marshall Islands",
  CODE800: "+800 International Freephone Service",
  CODE808: "+808 International Shared Cost Service",
  CODE850: "+850 Korea, North",
  CODE855: "+855 Cambodia",
  CODE856: "+856 Laos",
  CODE870: "+870 Inmarsat SNAC",
  CODE878: "+878 Universal Personal Telecoms",
  CODE880: "+880 Bangladesh",
  CODE881: "+881 Global Mobile Satellite System",
  CODE882: "+882 Mobile Satellite Service",
  CODE883: "+883 International Networks",
  CODE888: "+888 International Disaster Relief",
  CODE960: "+960 Maldives",
  CODE961: "+961 Lebanon",
  CODE962: "+962 Jordan",
  CODE963: "+963 Syria",
  CODE964: "+964 Iraq",
  CODE965: "+965 Kuwait",
  CODE966: "+966 Saudi Arabia",
  CODE967: "+967 Yemen",
  CODE968: "+968 Oman",
  CODE970: "+970 Palestinian territories",
  CODE971: "+971 United Arab Emirates",
  CODE972: "+972 Israel",
  CODE973: "+973 Bahrain",
  CODE974: "+974 Qatar",
  CODE975: "+975 Bhutan",
  CODE976: "+976 Mongolia",
  CODE977: "+977 Nepal",
  CODE979: "+979 International Premium Rate",
  CODE992: "+992 Tajikistan",
  CODE993: "+993 Turkmenistan",
  CODE994: "+994 Azerbaijan",
  CODE995: "+995 Georgia",
  CODE996: "+996 Kyrgyzstan",
  CODE998: "+998 Uzbekistan",
};
